const BOT_PATTERNS = [
  ' daum[ /]',
  ' deusu/',
  '(?:^|[^g])news(?!sapphire)',
  '(?<! (?:channel/|google/))google(?!(app|/google| pixel))',
  '(?<! cu)bots?(?:\\b|_)',
  '(?<!(?:lib))http',
  '(?<!cam)scan',
  '24x7',
  '@[a-z][\\w-]+\\.',
  '\\(\\)',
  '\\.com\\b',
  '\\b\\w+\\.ai',
  '\\bcursor/',
  '\\bmanus-user/',
  '\\bort/',
  '\\bperl\\b',
  '\\bplaywright\\b',
  '\\bsecurityheaders\\b',
  '\\bselenium\\b',
  '\\btime/',
  '\\|',
  '^[\\w \\.\\-\\(?:\\):%]+(?:/v?\\d+(?:\\.\\d+)?(?:\\.\\d{1,10})*?)?(?:,|$)',
  '^[\\w\\-]+/[\\w]+$',
  '^[^ ]{50,}$',
  '^\\d+\\b',
  '^\\W',
  '^\\w*search\\b',
  '^\\w+/[\\w\\(\\)]*$',
  '^\\w+/\\d\\.\\d\\s\\([\\w@]+\\)$',
  '^active',
  '^ad muncher',
  '^amaya',
  '^apache/',
  '^avsdevicesdk/',
  '^azure',
  '^biglotron',
  '^bot',
  '^bw/',
  '^clamav[ /]',
  '^claude-code/',
  '^client/',
  '^cobweb/',
  '^custom',
  '^ddg[_-]android',
  '^discourse',
  '^dispatch/\\d',
  '^downcast/',
  '^duckduckgo',
  '^email',
  '^facebook',
  '^getright/',
  '^gozilla/',
  '^hobbit',
  '^hotzonu',
  '^hwcdn/',
  '^igetter/',
  '^jeode/',
  '^jetty/',
  '^jigsaw',
  '^microsoft bits',
  '^movabletype',
  '^mozilla/\\d\\.\\d\\s[\\w\\.-]+$',
  '^mozilla/\\d\\.\\d\\s\\((?:compatible;)?(?:\\s?[\\w\\d-.]+/\\d+\\.\\d+)?\\)$',
  '^navermailapp',
  '^netsurf',
  '^offline',
  '^openai/',
  '^owler',
  '^php',
  '^postman',
  '^python',
  '^rank',
  '^read',
  '^reed',
  '^rest',
  '^rss',
  '^snapchat',
  '^space bison',
  '^svn',
  '^swcd ',
  '^taringa',
  '^thumbor/',
  '^track',
  '^w3c',
  '^webbandit/',
  '^webcopier',
  '^wget',
  '^whatsapp',
  '^wordpress',
  '^xenu link sleuth',
  '^yahoo',
  '^yandex',
  '^zdm/\\d',
  '^zoom marketplace/',
  'advisor',
  'agent\\b',
  'analyzer',
  'archive',
  'ask jeeves/teoma',
  'audit',
  'bit\\.ly/',
  'bluecoat drtr',
  'browsex',
  'burpcollaborator',
  'capture',
  'catch',
  'check\\b',
  'checker',
  'chrome-lighthouse',
  'chromeframe',
  'classifier',
  'cloudflare',
  'convertify',
  'crawl',
  'cypress/',
  'dareboost',
  'datanyze',
  'dejaclick',
  'detect',
  'dmbrowser',
  'download',
  'exaleadcloudview',
  'feed',
  'fetcher',
  'firephp',
  'functionize',
  'grab',
  'headless',
  'httrack',
  'hubspot marketing grader',
  'ibisbrowser',
  'infrawatch',
  'insight',
  'inspect',
  'iplabel',
  'java(?!;)',
  'library',
  'linkcheck',
  'mail\\.ru/',
  'manager',
  'measure',
  'monitor\\b',
  'neustar wpm',
  'node\\b',
  'nutch',
  'offbyone',
  'onetrust',
  'optimize',
  'pageburst',
  'pagespeed',
  'parser',
  'phantomjs',
  'pingdom',
  'powermarks',
  'preview',
  'proxy',
  'ptst[ /]\\d',
  'retriever',
  'rexx;',
  'rigor',
  'rss\\b',
  'scrape',
  'server',
  'sogou',
  'sparkler/',
  'speedcurve',
  'spider',
  'splash',
  'statuscake',
  'supercleaner',
  'synapse',
  'synthetic',
  'tools',
  'torrent',
  'transcoder',
  'url',
  'validator',
  'virtuoso',
  'wappalyzer',
  'webglance',
  'webkit2png',
  'whatcms/',
  'xtate/',
] as const

const BOT_PATTERN = BOT_PATTERNS.join(getPatternSeparator())
const FALLBACK_PATTERN = /bot|crawl|http|lighthouse|scan|search|spider/i

let cachedPattern: null | RegExp = null

export function useIsBot(userAgent?: null | string): boolean {
  const currentUserAgent = userAgent ?? (import.meta.client ? navigator.userAgent : '')

  return Boolean(currentUserAgent) && getPattern().test(currentUserAgent)
}

function getPattern(): RegExp {
  if (cachedPattern instanceof RegExp) {
    return cachedPattern
  }

  try {
    cachedPattern = new RegExp(BOT_PATTERN, 'i')
  } catch {
    cachedPattern = FALLBACK_PATTERN
  }

  return cachedPattern
}

function getPatternSeparator(): string {
  return '|'
}
